import React, { useState } from "react";
import { FaStar, FaRegStar } from "react-icons/fa";
import Rating from "react-rating";
import { Button, Input } from "reactstrap";
import { PRIMARY_TEXT_COLOR } from "../color";

const RatingSummary = ({
  heading,
  id,
  name,
  ratingsState,
  setRatingsState,
  size = 20,
  fractions = 2,
}) => {
  const handleRatingChange = (value) => {
    setRatingsState({
      ...ratingsState,
      [id]: ratingsState[id] === value ? 0 : value,
    });
  };

  const handleInputChange = (e) => {
    setRatingsState({
      ...ratingsState,
      [name]: e.target.value,
    });
  };

  const handleReset = () => {
    setRatingsState({
      ...ratingsState,
      [id]: 0
    });
  };


  return (
    <div className="star-rating-container mb-3 p-3 border rounded-lg shadow-sm bg-white">
      <div className="d-flex justify-content-between align-items-center">
        <p className="text-muted" style={{ fontSize: "12px" }}>{heading}</p>
        <button
          className="cancelBtn py-0 px-2 text-sm font-semibold text-primary hover:bg-gray-100 rounded-md transition duration-300"
          onClick={() => handleReset(0)} // Explicitly reset the rating to 0
        >
          Reset
        </button>
      </div>

      <div className="d-flex align-items-center">
        <Rating
          emptySymbol={<FaRegStar size={size} color="#ffe234" />}
          fullSymbol={<FaStar size={size} color="#ffe234" />}
          fractions={fractions}
          initialRating={ratingsState[id] || 0} // Get the rating for the specific id, default to 0
          onChange={handleRatingChange}
        />
        <span className="ml-2 text-green-600" style={{ fontSize: "14px" }}>
          {ratingsState[id] || 0}/5
        </span>
      </div>
      <span className="text-green-600" style={{ fontSize: "14px" }}>Remark</span>
      <Input
        type="textarea"
        name={name}
        style={{
          padding:"5px 10px"
        }}
        placeholder="Write your remark..."
        value={ratingsState[name] || ""}
        onChange={handleInputChange}
      />

    </div>
  );
};

export default RatingSummary;
